export type AmplifierProtocolLanguage =
  | 'en_US'
  | 'ru_RU'
  | 'zh_CN'
  | 'zh_HK'
  | 'es_ES'
  | 'fr_FR'
  | 'ja_JP';

export type AmplifierLocaleId = AmplifierProtocolLanguage;

export const AMPLIFIER_PROTOCOL_LANGUAGES: AmplifierProtocolLanguage[] = [
  'en_US',
  'ru_RU',
  'zh_CN',
  'zh_HK',
  'es_ES',
  'fr_FR',
  'ja_JP',
];

export const AMPLIFIER_LANGUAGE_OPTIONS: Array<{ value: AmplifierLocaleId; label: string }> = [
  { value: 'zh_CN', label: '简体中文' },
  { value: 'zh_HK', label: '繁體中文' },
  { value: 'en_US', label: 'English' },
  { value: 'ru_RU', label: 'Русский' },
  { value: 'es_ES', label: 'Español' },
  { value: 'fr_FR', label: 'Français' },
  { value: 'ja_JP', label: '日本語' },
];

const KNOWN_PROTOCOL: ReadonlySet<string> = new Set(AMPLIFIER_PROTOCOL_LANGUAGES);

export function isAmplifierProtocolLanguage(value: unknown): value is AmplifierProtocolLanguage {
  return typeof value === 'string' && KNOWN_PROTOCOL.has(value);
}

export function protocolToLocale(protocol: unknown): AmplifierLocaleId {
  if (isAmplifierProtocolLanguage(protocol)) return protocol;
  return 'en_US';
}

export function localeToProtocol(locale: AmplifierLocaleId): AmplifierProtocolLanguage {
  return locale;
}
